<template>
  <div class="search-results-container">

    <loading-overlay v-if="!isSearchComponentReady"></loading-overlay>
    <div v-if="authResponse && isSearchComponentReady">
      <div class="position-relative">
        <div class="eh-search-background-card"></div>
      </div>
      <div class="col-12 pt-4">
        <div class="container">
          <div class="row search-text-">
            <div class="col-12 search-text" >

              <span v-if="searchKeyword" >Search: <span :title="searchKeyword">{{searchKeyword}}</span> </span>
              <span v-else>&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="isSearchComponentReady">
      <div class="row eh-search-container search-wrapper" >
        <div class="col-12">
          <enterprise-search
              :env="appEnv"
              :es-title="CONSTANTS.AUTODESK_ONE_ENTERPRISE_SEARCH"
              :es-user-access-token="authResponse.accessToken"
              :es-user-id-token="authResponse.idToken"
              :user-id="authResponse.user.userName"
              :user-email="authResponse.user.email"
              :enable-url-params="true"
              @onSearchKeywordChanged="searchKeywordChanged"
              @onWebComponentSuccess="onESComponentReady"
              @onWebComponentError="onESComponentError"
              :key="componentKey"
              :customize-search="true"
              :enable-employee-hub-search="true"
          ></enterprise-search>

        </div>
      </div>
      <div class="container" v-if="!searchKeyword ">
          <div class="search-no-records-found" ><h4
          >Please type keywords to search</h4></div>
      </div>
    </div>
  </div>
</template>

<script>
import { safeImportComponent } from "@/utils/componentImportUtils";
import LoadingOverlay from "@/components/LoadingOverlay";
import * as CONSTANTS from "@/store/constants";
import {mapGetters} from "vuex";

export default {
  name: "SearchPage",
  components: {
    LoadingOverlay
  },
  computed: {
    ...mapGetters(["authResponse", "user","country"])
  },

  data() {
    return {
      CONSTANTS,
      appEnv: CURRENT_ENV,
      searchKeyword: null,
      search: null,
      componentKey: 0,
      isSearchComponentReady:false
    };
  },
  watch: {
    "user.userName": function() {
      //Re triggers the component
      this.componentKey++;
    },
    country: function() {
      this.componentKey++;
    }
  },
  created() {
    safeImportComponent(ES_COMPONENTS_URL  + "/enterprisesearch.umd.min.js");

    this.$nextTick(() => {
      this.componentKey++;
    });
  },
  methods: {
    onESComponentReady(){
      this.isSearchComponentReady = true;
    },
    onESComponentError(){
      this.isSearchComponentReady = true;
    },
    searchKeywordChanged(response) {
      if (response && response.detail[0]) {
        this.searchKeyword = response.detail[0]
      } else {
        this.searchKeyword = null;
      }
    },
  }
};
</script>
<style scoped>
.search-no-records-found {
  background-color: #f4f8fa;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, .05);
  border-color: #5bc0de;
  margin: 10px;
  margin-left: 0;
  padding: 40px;
  color: #979797;
}
.search-text {
  color: #000000;
  font-size: 36px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.search-results-container{
  min-height: 700px;
}
.search-results-container >>> .search-input{
  color: #000000 !important;
}


/* search component overrides */
.search-wrapper >>> .container {
  max-width: unset !important;
}
.search-wrapper >>> .search-input-wrapper {
  max-width: 1320px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
@media (min-width: 992px) {
  .search-wrapper >>>   .input-group {
    max-width: 50% !important;
  }
}
@media (min-width: 1320px) {
  .search-wrapper >>> .search-input-wrapper {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
.search-wrapper >>> .search-card-container,
.search-wrapper >>> .nav-bar-wrapper > .col-md-6 {
  max-width: 1320px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  flex: 0 0 100% !important;
}

</style>


// WEBPACK FOOTER //
// src/components/search/SearchPage.vue